import Service from "./Service";
import * as CONSTANTS from "../constants/constants";
import Swal from 'sweetalert2';


let http = axios.create({
  baseURL: `${CONSTANTS.API_V3_URL}`,
  timeout: 200000
});

/**
 * @type BomControleService
 */
export default class BomControleService extends Service {

    async checkSituation() {
        try {
            const response = await http.get("clients/situation", {
                headers: this.getHeaders(),
                timeout: 600000
            });
            return response.data;
        } catch (error) {
            console.error("Erro ao verificar situação:", error);
            throw error;
        }
    }
    situation_alert(locked = false) {
        try{
            const message = localStorage.getItem('message');
            const situation = localStorage.getItem('situation');
            const boleto_url = localStorage.getItem('boleto_url');
            const hasBoleto = !!boleto_url;
            const htmlContent = `
                <div style="text-align: left; line-height: 1.5; font-size: 15px; color: #333;">
                <p>${message || "Situação verificada com sucesso."}</p>
                </div>
            `;
            if (situation == 'blocked' || situation == 'warning'){
                    Swal.fire({
                        title: "<strong>Situação da sua conta</strong>",
                        html: htmlContent,
                        icon: hasBoleto ? "warning" : "info",
                        showCancelButton: !locked,
                        showConfirmButton: hasBoleto,
                        confirmButtonText: "Ver boleto",
                        cancelButtonText: "Fechar",
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#aaa", 
                        reverseButtons: true,
                        width: 500,
                        showDenyButton: true,
                        denyButtonText: "Suporte",
                        denyButtonColor: "#00b894",
                        customClass: {
                            popup: "swal2-shadow",                        
                        },
                        allowOutsideClick: !locked,
                        allowEscapeKey: !locked,
                        allowEnterKey: !locked,
                        preDeny: () => {
                            window.open('https://wa.me/5581984400160', '_blank');
                            return false;
                        },
                        preConfirm: () => {
                            window.open(boleto_url, "_blank");
                            return false;
                        }
                        });
            }
        }catch(error){
            console.error("Erro inesperado ao exibir alerta:", error);
        }
        
    }

}
